import { createWellnessMap, processData } from "./utils/dataProcessors";
import logger from "../../utils/logger";

// TODO: WE NEED TO PULL 123Wellness data in the same format as other users
export async function get123WellnessData(state, user, wellness) {
  try {
    const metrics = {};
    const startTime = performance.now();

    // Execute and time each data fetching operation
    const { districts: districtsRaw, allStudents, schools: allSchools } = user;

    // Time createWellnessMap operation
    const wellnessMapStart = performance.now();
    const wellnessMapData = createWellnessMap(wellness.raw);
    metrics.createWellnessMap = performance.now() - wellnessMapStart;

    // Time processData operation
    const processDataStart = performance.now();
    const {
      districts,
      studentData,
      allWellnessPoints,
      currentDictionary,
      compareDictionary,
      recordCounter,
    } = processData(
      districtsRaw,
      allSchools,
      allStudents,
      wellnessMapData,
      state,
      true,
    );
    metrics.processData = performance.now() - processDataStart;

    // Calculate total execution time
    metrics.totalExecutionTime = performance.now() - startTime;

    logger.log("Performance Metrics (ms):", metrics);
    logger.log(
      "Users practiced a total of ",
      recordCounter,
      "all students: ",
      allStudents.length,
    );

    return {
      districts,
      allWellnessPoints,
      allStudents,
      studentData,
      currentDictionary,
      compareDictionary,
      loading: false,
      counter: recordCounter,
      metrics, // Include metrics in the return object
      chosenDistrict: "All Districts",
      chosenSchool: "All Schools",
      chosenClass: "All Classes",
    };
  } catch (error) {
    logger.error("Error in get123WellnessData:", error);
    throw error;
  }
}
